<template>
  <div class="loader" :style="loaderStyle">
    <div class="dot-box">
      <div class="dot dot-1" :style="dotStyle"></div>
      <div class="dot dot-2" :style="dotStyle"></div>
      <div class="dot dot-3" :style="dotStyle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#000',
    },
    background: {
      type: String,
      default: '#ccc',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    }
  },
  computed: {
    dotStyle() {
      return 'background: ' + this.color + ';'
    },
    loaderStyle() {
      return 'background: ' + this.background + ';width: ' + this.width + ';height: ' + this.height + ';'
    }
  },
}
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dot-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60px;
  height: 60px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;

  &.dot-1 {
    animation: dot-jump .5s cubic-bezier(.77, .47, .64, .28) alternate infinite;
  }
  &.dot-2 {
    animation: dot-jump .5s .2s cubic-bezier(.77, .47, .64, .28) alternate infinite;
  }
  &.dot-3 {
    animation: dot-jump .5s .4s cubic-bezier(.77, .47, .64, .28) alternate infinite;
  }
}

@keyframes dot-jump {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-15px);
  }
}
</style>